import { epiFormSubmission } from "../TrackingInformation";
export function initFormTracking() {
    setTimeout(() => {
        document
            .querySelectorAll("form.EPiServerForms")
            .forEach((form) => {
            form.addEventListener("submit", () => handleFormSubmit(form), true);
        });
    });
}
function handleFormSubmit(form) {
    try {
        if (!form.checkValidity())
            return;
        const formName = getFormName(form);
        const formData = new FormData(form);
        const serialisedData = serializeForm(form, formData);
        const fieldList = normalizeData(serialisedData);
        epiFormSubmission(form.id, formName, fieldList);
    }
    catch (error) {
        console.error("Form GA4 submission failed:", error);
    }
}
function serializeForm(form, formData) {
    const result = {};
    form.querySelectorAll("div.Form__Element").forEach((fieldElement) => {
        var _a, _b, _c, _d, _e, _f, _g;
        const input = fieldElement.querySelector("input, select, textarea");
        const fieldId = (_a = fieldElement.getAttribute("data-f-element-name")) !== null && _a !== void 0 ? _a : "";
        let label;
        if (fieldElement.classList.contains("FormChoice")) {
            const groupLabel = ((_b = fieldElement.previousElementSibling) === null || _b === void 0 ? void 0 : _b.classList.contains("Form__Element__Caption"))
                ? fieldElement.previousElementSibling
                : fieldElement.querySelector(".Form__Element__Caption");
            label = ((_c = groupLabel === null || groupLabel === void 0 ? void 0 : groupLabel.textContent) === null || _c === void 0 ? void 0 : _c.trim()) || fieldId;
        }
        else {
            // Normal fields
            label =
                ((_e = (_d = fieldElement
                    .querySelector(".Form__Element__Caption, label")) === null || _d === void 0 ? void 0 : _d.textContent) === null || _e === void 0 ? void 0 : _e.trim()) ||
                    ((_f = input === null || input === void 0 ? void 0 : input.getAttribute("aria-label")) === null || _f === void 0 ? void 0 : _f.trim()) ||
                    ((_g = input === null || input === void 0 ? void 0 : input.getAttribute("placeholder")) === null || _g === void 0 ? void 0 : _g.trim()) ||
                    fieldId;
        }
        label = label.replace(/\*$/, "").trim();
        result[label] = formData.getAll(fieldId);
    });
    return result;
}
function normalizeData(data) {
    const normalized = {};
    for (const [key, value] of Object.entries(data)) {
        if (Array.isArray(value)) {
            normalized[key] = value.length === 1 ? value[0] : value;
        }
        else {
            normalized[key] = value;
        }
    }
    return normalized;
}
function getFormName(form) {
    var _a, _b, _c, _d, _e, _f, _g;
    const container = (_a = form.closest("div")) === null || _a === void 0 ? void 0 : _a.parentElement;
    const heading = container === null || container === void 0 ? void 0 : container.querySelector("h1, h2, h3, h4");
    const headingText = (_b = heading === null || heading === void 0 ? void 0 : heading.textContent) === null || _b === void 0 ? void 0 : _b.trim();
    if (headingText)
        return headingText;
    const epiName = (_g = (_f = (_e = (_d = (_c = window) === null || _c === void 0 ? void 0 : _c.epi) === null || _d === void 0 ? void 0 : _d.EPiServer) === null || _e === void 0 ? void 0 : _e.Forms) === null || _f === void 0 ? void 0 : _f[form.id]) === null || _g === void 0 ? void 0 : _g.Name;
    if (epiName)
        return epiName;
    return headingText || "unknown-form";
}
